import { MenuItems } from '../../core/models/sidebar/menu-items.model';

export const menuTopItems: MenuItems[] = [
  {
    title: 'dashboard.dashboardMenuTitle',
    icon: 'fa-solid fa-clipboard-list',
    link: '/dashboard/main',
    permissions: [],
  },
  {
    title: 'Organizations',
    icon: 'fa-solid fa-building',
    link: '/organization/organizations',
    permissions: ['get_list_organization_claim'],
  },
  {
    title: 'users',
    icon: 'fa-solid fa-user',
    link: '/user/users',
    permissions: ['get_list_user_claim'],
  },
  {
    title: 'workList',
    icon: 'fa-solid fa-list',
    link: '/work-list/worklist',
    permissions: ['get_list_wound_claim', 'get_list_wound_consultation_claim'],
  },

  // {
  //   title: 'consultations',
  //   icon: 'fa-solid fa-file-lines',
  //   link: '/consultation/list',
  //   roles: ['Dermatologist', 'Admin', 'OrganizationAdmin'],
  // },
  {
    title: 'appoinmentList',
    icon: 'fa-regular fa-rectangle-list',
    link: '/appointment/list',
    permissions: [],
  },
  {
    title: 'patientList',
    icon: 'fa-solid fa-users',
    link: '/patient/list',
    permissions: ['get_list_patient_claim'],
  },
  {
    title: 'roleList.title',
    icon: 'fa-solid fa-user-shield',
    link: '/role/list',
    permissions: ['get_list_role_claim'],
  },
];
